import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { compact, proxied } from "@/lib/feed";

const rise = (d) => ({ initial: { opacity: 0, y: 30 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.8, delay: d, ease: [0.2, 0.7, 0.2, 1] } });

const Stat = ({ label, value, testid }) => (
  <div data-testid={testid}>
    <div className="font-display text-3xl md:text-4xl">{value}</div>
    <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--ash)] mt-1">{label}</div>
  </div>
);

export const Hero = ({ profile }) => (
  <section data-testid="hero-section" className="relative px-6 md:px-12 lg:px-20 pt-20 md:pt-28 pb-20">
    <motion.div {...rise(0)} className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-[var(--ash)]">
      <span className="pulse-dot h-2 w-2 rounded-full bg-[var(--volt)]" /> Live from Instagram
    </motion.div>
    <motion.h1 {...rise(0.1)} data-testid="hero-title" className="font-display text-5xl sm:text-6xl lg:text-8xl font-light leading-[0.95] tracking-tight mt-8 max-w-5xl">
      Trending tech news, <em className="italic text-[var(--volt)] font-normal">as it breaks.</em>
    </motion.h1>
    <motion.p {...rise(0.2)} data-testid="hero-bio" className="mt-8 max-w-xl text-base md:text-lg text-[var(--ash)] leading-relaxed">
      {profile?.biography || "HostNode tracks what's moving in tech: launches, leaks and the stories everyone will be talking about tomorrow. Every new post lands here automatically."}
    </motion.p>
    <motion.div {...rise(0.3)} className="mt-14 flex flex-wrap items-end gap-12">
      <div className="flex items-center gap-4">
        {profile?.profile_pic_url && (
          <img data-testid="profile-avatar" src={proxied(profile.profile_pic_url)} alt={profile.username} className="h-14 w-14 rounded-full object-cover ring-1 ring-[var(--line)]" />
        )}
        <a
          href={profile?.url || "https://www.instagram.com/hostnode.cloud/"}
          target="_blank"
          rel="noreferrer"
          data-testid="hero-follow-btn"
          className="group inline-flex items-center gap-2 rounded-full bg-[var(--volt)] px-7 py-4 text-sm font-semibold text-[var(--ink)] transition-transform duration-300 hover:-translate-y-0.5"
        >
          Follow on Instagram
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
        </a>
      </div>
      {profile && (
        <div className="flex gap-12">
          <Stat testid="stat-followers" label="Followers" value={compact(profile.followers)} />
          <Stat testid="stat-posts" label="Posts" value={compact(profile.post_count)} />
        </div>
      )}
    </motion.div>
  </section>
);
